import { useMemo } from 'react';
import { useTableBaseInputProps } from './baseInputProps';

/**
 *
 * @param { string } name - имя поля
 * @param { Object } data - Данные
 * @param { Object } fields - Поля
 * @param { Object } errors - Ошибки
 * @param { function } onChange - handler
 * @param { number } rowIndex - rowIndex
 * @param { boolean } isReadOnly - isReadOnly
 * @param {string[]} readOnlyFelds - readOnlyFelds
 * @param { array } filter - фільтр
 * @returns {{
 *  onChange: (function(*, *): *),
 *  description: string,
 *  readOnly: boolean,
 *  controlId: string,
 *  value: Object,
 *  required: boolean,
 *  errors: Array,
 *  backend: string,
 *  }}
 */

export const useItemInputProps = (
  name,
  data,
  fields,
  errors,
  onChange,
  rowIndex,
  isReadOnly = false,
  readOnlyFelds = [],
) => {
  const baseProps = useTableBaseInputProps(
    name,
    data,
    fields,
    errors,
    onChange,
    rowIndex,
    isReadOnly,
    readOnlyFelds,
  );
  const backend = useMemo(
    () => (fields && fields[name] ? fields[name].resource : null),
    [fields, name],
  );
  return useMemo(
    () => ({
      ...baseProps,
      backend,
      canErase: !baseProps.required,
    }),
    [backend, baseProps],
  );
};

export default useItemInputProps;
